import { render, staticRenderFns } from "./TheNotifications.vue?vue&type=template&id=12218e4f&scoped=true"
import script from "./TheNotifications.vue?vue&type=script&lang=ts"
export * from "./TheNotifications.vue?vue&type=script&lang=ts"
import style0 from "./TheNotifications.vue?vue&type=style&index=0&id=12218e4f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12218e4f",
  null
  
)

export default component.exports